import React from 'react'
import './HeaderActions.css';

function HeaderActions({children}) {
  return (
    <div className='headerActions'>
      {children}
    </div>
  )
}

export default HeaderActions
